// frontend/packs/errors.js

/* eslint-disable import/first, import/newline-after-import */

import { Application } from 'stimulus';
export const localePrompt = Application.start(); // eslint-disable-line import/prefer-default-export

import '../components/global/locale-prompt/locale-prompt.css';

import LocalePromptController from '../components/global/locale-prompt/locale-prompt-controller';
localePrompt.register('locale-prompt', LocalePromptController);
